import { Button, Drawer } from 'antd';
import { FC, useMemo, useState } from 'react';
import { getAPIEnv } from 'utils/API';
import APIManager from './APIManager';
import './style.scss';

/**
 * 仅qa环境显示入口
 */
const Environment: FC = __DEV__
    ? () => {
          const [open, setOpen] = useState(false);
          const curEnv = useMemo(() => getAPIEnv() || 'test', []);

          return (
              <>
                  <Drawer className="environment-entry-root" closable={false} placement="right" open={open}>
                      <APIManager onClose={() => setOpen(false)} />
                  </Drawer>
                  <div className="qax-switcher">
                      <Button size="small" className="ml-2" onClick={() => setOpen(true)}>
                          配置接口环境(当前{curEnv})
                      </Button>
                  </div>
              </>
          );
      }
    : () => null;

export default Environment;
